// extracted by mini-css-extract-plugin
export var select = "_py-0";